// @flow

export const COOKIE_SETTINGS_PAGE_URL = 'https://stripe.com/cookie-settings';
export const COOKIE_POLICY_URL = 'https://stripe.com/cookies-policy/legal';
